import React from 'react'
import Skeleton from "@material-ui/lab/Skeleton";
function FollowSkeleton() {
    return (
        <>
            <div className="container-fluid">
                <div className='row'>
                    <div className="col-md-1 px-0">
                        <Skeleton variant="circle" className="mb-2 mr-4" width={50} height={50} />
                    </div>
                    <div className="col-md-11">
                        <Skeleton variant="rect" className="mb-2" height={50} width='100%' />
                    </div>
                    <div className="col-md-1 px-0">
                        <Skeleton variant="circle" className="mb-2 mr-4" width={50} height={50} />
                    </div>
                    <div className="col-md-11">
                        <Skeleton variant="rect" className="mb-2" height={50} width='100%' />
                    </div>
                    <div className="col-md-1 px-0">
                        <Skeleton variant="circle" className="mb-2 mr-4" width={50} height={50} />
                    </div>
                    <div className="col-md-11">
                        <Skeleton variant="rect" className="mb-2" height={50} width='100%' />
                    </div>
                </div>
            </div>
        </>
    )
}

export default FollowSkeleton
